import React, { Component } from 'react'
import './index.less'
import langM from './lang'
import {
  inject,
  observer,
  setDocumentTitle,
  setUidToken,
  getlangV2,
  setlang,
  forbidScroll,
  throttle
} from '../../../helper/devTools.js'
import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css';
import config from 'src/core/config'
import Message from '../../../component/Message'
import LoadingComp from '../../../component/LoadingComp'
import http from 'src/helper/http'
import localstorage from 'src/helper/localstorage'
import hybridRouter from 'src/core/hybrid-router'
import { isRussiaHost } from 'src/helper/tool'
@inject('store')
@observer

export default class extends Component {
  constructor(props) {
    super(props)
    this.rechargeStore = this.props.store.register('app/recharge')
    setDocumentTitle('Recharge')
    this.handleLang = throttle(this.handleLang, 1000)
  }
  state = {
    lang: langM.ar,
    payState: 1,
    payItemState: 1,
    isNationMore: false,
    priceIndex: -1,
    isLang: false,
    isLangShow: false,
    language: 'en',
    // 是否选择policy
    isPolicy: true,

    // 是否查询到该用户
    searchUser: false,
    noFoundUser: false,
    noNull: false,
    country:17,
    // 国家
    hosList: [],
    allList: [],

    // 语言适配
    langObj: {},
    langState: 0,

    // 输入框
    inputValue: "",

    price: "",
    SAR: "",
    rubyPayList: [],
    // 轮播图列表
    bannerList: [
      {
        img: "/img/app/recharge/banner/bg1.png",
        url: window.location.origin + `/#/app/refund` + `?language=${this.language}`
      }
    ],

    payList: [],
    selNationName: "",
    userInfo: {},
    priceList: [],
    sendGold: 0,
    sendPrice: 0,
    mapList: [],
    payId: 1,
    goldOrRuby: false,
    type: 'gold',
    desc: "",
    initShow: true,
    langShow: true,
    showWhatPay: 0
  }
  async initLang() {
    let { language } = this.props.location.query
    language = await getlangV2(language, langM)
    if (config.host == "https://api-test.thechatie.com") {
      this.setState({
        langShow: language == 'zh' ? true : false
      })
    }
    this.setState({
      lang: setlang(language, langM),
      language: language,
      bannerList: [
        {
          img: "/img/app/maliciousrefund/banner_en.png",
          url: window.location.origin + `/#/app/refund` + `?language=en`
        },
        {
          img: "/img/app/maliciousrefund/banner_en.png",
          url: window.location.origin + `/#/app/refund` + `?language=en`
        },
        {
          img: "/img/app/maliciousrefund/banner_en.png",
          url: window.location.origin + `/#/app/refund` + `?language=en`
        },
        {
          img: "/img/app/recharge/banner/bg1.png",
          url: window.location.origin + `/#/app/refund` + `?language=ar`
        },

        {
          img: "/img/app/maliciousrefund/banner_tr.png",
          url: window.location.origin + `/#/app/refund` + `?language=tr`
        },
      ]
    })
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    return uid
  }

  initLangObj() {
    if (this.state.language == 'zh') {
      this.setState({
        langObj: langM.zh,
        langState: 1
      })
    }
    if (this.state.language == 'en') {
      this.setState({
        langObj: langM.en,
        langState: 2
      })
    }
    if (this.state.language == 'ar') {
      this.setState({
        langObj: langM.ar,
        langState: 3
      })
    }
    if (this.state.language == 'tr') {
      this.setState({
        langObj: langM.tr,
        langState: 4
      })
    }
  }

  initSwiper() {
    // 分页器
    const mySwiper = new Swiper('.swiper', {
      slidesPerView: 1
    })
    this.setState({
      mySwiper
    })
  }

  async initNationList() {
    try {
      // 国家选择列表
      let nation = await this.rechargeStore.getNationList()
      // 默认国家支付方法列表
      let payList = await this.rechargeStore.payList(nation && nation.default.countryId || 17, 0)//这里可以传一个参数去取gold还是ruby
      this.setState({
        hosList: nation && nation.hot.filter(item => ![34, 40, 42, 15].includes(item.countryId)), // 过滤 摩洛哥,阿尔及利亚,埃及,也门
        allList: nation && nation.all.filter(item => ![34, 40, 42, 15].includes(item.countryId)), // 过滤 摩洛哥,阿尔及利亚,埃及,也门
        payList: payList,
        selNationName: nation && nation.default.countryName || 'KSA'
      })
      this.getRubyList()
    } catch (error) {
      this.refs.msg.show("error")
      return new Error(error)
    }
  }
  async getRubyList() {
    try {
      // 国家选择列表
      let nation = await this.rechargeStore.getNationList()
      // 默认国家支付方法列表
      let rubyPayList = await this.rechargeStore.payList(nation && nation.default.countryId || 17, 1)//这里可以传一个参数去取gold还是ruby
      this.setState({
        rubyPayList
      })
    } catch (error) {
      this.refs.msg.show("error")
      return new Error(error)
    }
  }
  async componentWillMount() {
    let a = window.location
    // if ([
    //   'www.chatie.live',
    //   'chatie.live',
    //   'web.thechatie.com',
    //   'thechatie.com',
    //   'www.thechatie.com',
    //   'hoby.chat',
    //   'wwww.hoby.chat'
    // ].includes(a.host)) {
    window.location.replace(isRussiaHost() ? config.hostHybridRu : config.hostHybrid + hybridRouter.recharge)
    // }
    this.initLang()
    let uid = await this.initUid()
    await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    this.setState({
      uid: uid
    })
    this.initLangObj()
    this.initSwiper()
    let isPaypalCb = localstorage.get('whatRecharge')
    if (isPaypalCb && isPaypalCb == 2) {
      let haduid = localstorage.get('apprechangeUid')
      await this.setState({ inputValue: haduid })
      await this.onHandleSearch(haduid)
    } else {
      this.initNationList()
    }
    this.setState({
      initShow: false
    })
  }

  async componentDidMount() {

  }
  ioewelID = null
  hadCreat = false
  mapTxt(v) {
    return new Map([
      ["eId", this.state.langObj.eId],
      ["eNation", this.state.langObj.eNation],
      ["c", this.state.langObj.ePayMethods],
      ["eRechargeGold", this.state.langObj.eRechargeGold],
      ["ePolicy", this.state.langObj.ePolicy],
    ]).get(v)
  }


  /**
  * @description 选择国家
  */
  handleNationSel(state) {
    forbidScroll(state)
    this.setState({
      isNationMore: state
    })
  }

  /**
  * @description 下拉语言动画操作
  */
  handleLang(state) {
    if (!this.state.isLang) {
      this.setState({
        isLangShow: state
      })
      setTimeout(() => {
        this.setState({
          isLang: state
        })
      }, 10);
    } else {
      this.setState({
        isLang: false
      })
      setTimeout(() => {
        this.setState({
          isLangShow: false
        })
      }, 800);
    }
  }

  /**
  * @description 是否选择同意policy
  */
  handlePolicy() {
    this.setState({
      isPolicy: !this.state.isPolicy
    })
  }

  /**
  * @description 切换模式显示
  */
  langModeTxt() {
    if (this.state.langState == 1) {
      return `中文`
    }
    if (this.state.langState == 2) {
      return `English`
    }
    if (this.state.langState == 3) {
      return `بالعربية`
    } if (this.state.langState == 4) {
      return `Türkiye`
    }
  }

  /**
  * @description 修改语言
  */
  onChangeLang(state) {
    let langMode = {}
    if (state == 1) {
      langMode = langM.zh
    }
    if (state == 2) {
      langMode = langM.en
    }
    if (state == 3) {
      langMode = langM.ar
    }
    if (state == 4) {
      langMode = langM.tr
    }
    this.handleLang(true)
    this.setState({
      langState: state,
      langObj: langMode
    })
  }

  /**
  * @description 输入
  */
  handleInput(e) {
    const val = e.target.value
    this.setState({
      inputValue: val
    })
  }

  /**
  * @description 查找ID
  */
  async onHandleSearch(losuid) {
    let { inputValue, payState } = this.state
    let cnfe = losuid ? losuid : inputValue
    let news = cnfe + ''
    try {
      if (news.trim() == "" && news == "") {
        this.setState({
          noNull: true,
          noFoundUser: false
        })
        return
      }
      let search = await this.rechargeStore.verifyUser(news)
      if (search && search.code == 1) {
        this.setState({
          noNull: true,
          noFoundUser: false
        })
        return
      }
      if (search == null) {
        this.setState({
          noNull: false,
          noFoundUser: true
        })
        return
      }
      if (search) {
        this.setState({
          userInfo: search,
          searchUser: true,
          noFoundUser: false,
          noNull: false,
        })
        let isPaypalCb = localstorage.get('whatRecharge')
        let countryId = localstorage.get('country')
        if (isPaypalCb && isPaypalCb == 2) {
          let payList = await this.rechargeStore.payList(countryId, 0)
          let rubyPayList = payList
          let hadruby = localstorage.get('apprechangePaypalType')
          let priceIndex = localstorage.get('apprechangePayIndex')
          let idf = hadruby && hadruby == 2 ? rubyPayList.find(item => item.id == 999) : payList.find(item => item.id == 999)
          this.setState({
            goldOrRuby: hadruby && hadruby == 2 ? true : false, priceIndex, payId: 999, payState: 2, identifier: idf.list[priceIndex].identifier, payList: payList.length > 0 ? payList : [],
            rubyPayList: rubyPayList.length > 0 ? rubyPayList : [],
          })
          let okOrno = localstorage.get('appReaStatus')
          if (okOrno && okOrno == 201) {
            this.refs.msg.show(this.state.lang.successful)
          } else if (okOrno && okOrno != 201) {
          }
          localstorage.remove('apprechangePaypalType')
          localstorage.remove('apprechangePayIndex')
          localstorage.remove('appReaStatus')
          localstorage.remove('whatRecharge')
          localstorage.remove('apprechangeUid')
        }else{
          let payList = await this.rechargeStore.payList(search.countryId, 0)
          this.setState({
            payList: payList.length > 0 ? payList : [],
          })
        }
      }
      localstorage.remove('countryId')
    } catch (error) {
      console.log(error)
      this.refs.msg.show("error")
      return new Error(error)
    }
  }
  componentWillUnmount() {

  }
  //paypal 充值
  paypalRecharge = async () => {
    this.setState({ initShow: true })
    let { identifier, userInfo: { uid }, goldOrRuby, priceIndex, country } = this.state
    console.log(identifier, uid, goldOrRuby, priceIndex)
    localstorage.set('apprechangePaypalType', goldOrRuby ? 2 : 1) // 设置充值类型
    localstorage.set('apprechangePayIndex', priceIndex)  //充值参数
    localstorage.set('apprechangeUid', uid) //储存uid
    localstorage.set('whatRecharge', 2) // 
    localstorage.set('country', 2)
    http.post('/withoutsign/paypal/order/pay', {
      "uid": uid,
      "Identifier": identifier,
      "id": 1
    }).then((response) => {
      let a = JSON.parse(response.res.msg);
      let url = a.links[1].href //存储确认订单路径
      //let pons = window.open(url)
      window.location.href = url
      this.setState({ initShow: false })
    })
  }
  /**
  * @description 充值操作
  */
  async onHandleRecharge() {
    try {
      // 过滤前提条件
      if (!(this.state.userInfo && this.state.userInfo.uid)) {
        this.refs.msg.show(this.mapTxt("eId"))
        return
      }
      if (!(this.state.selNationName)) {
        this.refs.msg.show(this.mapTxt("eNation"))
        return
      }
      if (!(this.state.payId)) {
        this.refs.msg.show(this.mapTxt("ePayMethods"))
        return
      }
      if (!(this.state.identifier)) {
        this.refs.msg.show(this.mapTxt("eRechargeGold"))
        return
      }
      if (!(this.state.isPolicy)) {
        this.refs.msg.show(this.mapTxt("ePolicy"))
        return
      }
      if (this.state.payId == 999) {
        return this.paypalRecharge()
      }
      if (this.state.payId == 888) {
        return  this.razerPayFn()
      }
      // 再次确保前提条件
      const conditions = this.state.userInfo && this.state.userInfo.uid && this.state.payId && this.state.identifier && this.state.isPolicy
      if (conditions) {
        let res = await this.rechargeStore.placeOrder({
          uid: this.state.userInfo && this.state.userInfo.uid,
          identifier: this.state.identifier,
          id: this.state.payId,
          frontCallbackURL: window.location.origin + `/#/app/recharge`
        })
        if (res && res.code != 0) {
          this.refs.msg.show(res && res.msg)
          return
        }
        if (res && res.code == 0) {
          this.setState({
            url: res && res.res && res.res.redirectUrl,
            inputValue: ""
          })
          window.location.href = res && res.res && res.res.redirectUrl
        }
      }
    } catch (error) {
      this.refs.msg.show("error")
      return new Error(error)
    }
  }
  
  razerPayFn = async()=>{
    let { userInfo, identifier, payId } = this.state
    let res = await http.post('/withoutsign/razer/pay',{
      uid: userInfo && userInfo.uid,
      identifier: identifier,
      id: payId,
      frontCallbackURL: window.location.origin + `/#/app/recharge`
    })
    if (res.code == 0 ) {
      window.location.href = res.res.paymentUrl
    }
  }
  /**
   * @description 更新国家名字显示
   * @param nId 国家id
   */
  updateNationName(nId) {
    let name = ""
    this.state.hosList.map((item) => {
      if (item.countryId == nId) {
        name = item.countryName
      }
    })
    this.state.allList.map((item) => {
      if (item.countryId == nId) {
        name = item.countryName
      }
    })
    this.setState({
      selNationName: name
    })
  }

  /**
   * @description 选择国家支付方式
   * @param nId 国家id
   */
  async onHandlePayNationList(nId, type) {
    // 取消支付方式的下拉状态  选择国家
    this.setState({
      payState: 1
    })

    // 没有传递nId
    if (!nId) {
      return
    }
    // 关闭选择国家
    this.handleNationSel(false)
    // 请求国家支付方式列表
    let payList = await this.rechargeStore.payList(nId, 0)
    this.setState({
      payList: payList,
      country:nId
    })
    // 更新国家名字
    this.updateNationName(nId)
  }

  /**
   * @description 重置查询信息
   */
  onClearId() {
    this.setState({
      searchUser: false,
      userInfo: {},
      priceIndex: -1
    })
  }

  /**
   * @description 跳转到反馈页
   */
  toFeedback() {
    const url = window.location.origin + `/#/app/service/feedback`
    window.location.href = url
  }


  /**
  * @description 充值额度选择组件
  */
  payPriceComp(state, list) {
    let { payState, goldOrRuby, initShow, payId } = this.state
    const isShow = payState == state ? "flex" : "none"
    const isRuby = goldOrRuby ? true : false
    const handlePrice = async (i, gold, price, identifier) => {
      if (!this.state.userInfo.uid) { // 未选择充值ID
        this.refs.msg.show(this.mapTxt("eId"))
        this.setState({
          priceIndex: -1
        })
        return
      }
      this.setState({
        identifier: identifier,
        sendGold: gold,
        sendPrice: price,
        priceIndex: i
      })
    }
    return (<div className="official-recharge-pay-main" style={{ display: `${isShow}` }} key={902}>
      {
        list && list.map((item, index) => {
          return (!initShow &&
            <div
              key={index}
              className={`official-recharge-pay-main-item ${this.state.priceIndex == index ? "official-recharge-pay-main-item-active" : ""}`}
              onClick={() => { handlePrice(index, item.coin, item.price, item.identifier) }}>
              <div className="gold">
                {!isRuby && <img src="/img/gold.png" alt="" />}
                {isRuby && <img src="/img/app/ruby/icon_ruby_new.png" style={{ width: '0.32rem', height: '0.28rem' }} alt="" />}
                <span>{item.coin}</span>
              </div>
              <div className="price">{item.price / 100} {item.currency}</div>
            </div>
          )
        })
      }
    </div>
    )
  }

  /**
  * @description 下拉支付方法组件
  */
  payMethodComp(img, txt, state, id) {
    let { goldOrRuby, rubyPayList, payList, priceIndex } = this.state
    const handleState = async (nid) => {
      // 清空上一次选中数据
      this.setState({
        priceIndex: -1,
        payId: nid,
        identifier: null,
        sendGold: null,
        sendPrice: null,
      })
      // 重复点击的状态
      let arrList = goldOrRuby ? rubyPayList : payList
      if (this.state.payState != state) {
        this.setState({
          priceList: arrList && arrList[state - 1] && arrList[state - 1].list,
          payState: state
        })
      }

    }
    return (
      <div className="official-recharge-pay-item" onClick={() => { handleState(id) }}>
        <div className="info">
          <div className="icon">
            <img src={img} alt="" className={`${img.includes("pay3") ? "pic" : ""}`} />
          </div>
          <div className="txt">
            {txt}
          </div>
        </div>
        <div className={`more ${this.state.payState == state ? "more-reverse" : ""}`}>
          {state == this.state.payState && <img src="/img/app/recharge/icon_common_checkmar.png" alt="" />}
        </div>
      </div>
    )
  }

  /**
  * @description 充值和policy组件
  */
  /**
  * @description 国家选择展示组件
  */
  nationSelComp() {
    let { } = this.state
    return (
      <div className="official-recharge-nation-sel"
        style={{ transform: `translateY(${this.state.isNationMore ? "0" : "99.9vh"})` }}>
        <div className="official-recharge-nation-sel-wrap">
          <div className="hot-main">
            <div className="title">
              <span>{this.state.langObj.hot}</span>
              <div className="icon" onClick={() => { this.handleNationSel(false) }}></div>
            </div>
            <div className="content">
              {
                this.state.hosList && this.state.hosList.map((item, index) => {
                  return (
                    <div
                      className="content-item"
                      key={index}
                      onClick={() => { this.onHandlePayNationList(item.countryId, 'hot') }}>
                      <img src={item.countryIcon} alt="" />
                      <span>{item.countryName}</span>
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className="all-main">
            <div className="title">{this.state.langObj.all}</div>
            <div className="content">
              {
                this.state.allList && this.state.allList.map((item, index) => {
                  return (
                    <div
                      className="content-item"
                      key={index}
                      onClick={() => { this.onHandlePayNationList(item.countryId, 'all') }}>
                      <img src={item.countryIcon} alt="" />
                      <span>{item.countryName}</span>
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

  /**
  * @description 国家icon模块组件
  */
  selNationComp() {
    return (
      <div className="official-recharge-nation" onClick={() => { this.handleNationSel(true) }}>
        <div className="nation">
          <div className="icon"></div>
          <div className="txt">
            {this.state.selNationName}
            <span style={{ display: `${this.state.selNationName ? "none" : "block"}` }}>{this.state.langObj.enterNation}</span>
          </div>
        </div>
        <div className="more"></div>
      </div>
    )
  }

  /**
  * @description 头部组件
  */
  headerComp() {
    let { goldOrRuby } = this.state
    return (
      <div className="official-recharge-header">
        <div className="official-recharge-header-top">
          <div className="logo"></div>
          <div className="language">
            <div className="icon"></div>
            <div className="txt">
              <span onClick={() => { this.handleLang(true) }}>{this.langModeTxt()}</span>
              <div className="lang-more-content-wrap" style={{
                display: `${this.state.isLangShow && this.state.langState != 3 ? "block" : "none"}`
              }}>
                <div className="lang-more-content" style={{ transform: `translateY(${this.state.isLang ? "0rem" : "-30vh"})` }}>
                  <div className="lang-more-content-item" onClick={() => { this.onChangeLang(1) }}>
                    <img src="/img/app/recharge/yes.png" alt="" style={{ display: `${this.state.langState == 1 ? "block" : "none"}` }} />
                    <span>中文</span>
                  </div>
                  <div className="lang-more-content-item" onClick={() => { this.onChangeLang(2) }}>
                    <img src="/img/app/recharge/yes.png" alt="" style={{ display: `${this.state.langState == 2 ? "block" : "none"}` }} />
                    <span>English</span>
                  </div>
                  <div className="lang-more-content-item" onClick={() => { this.onChangeLang(3) }}>
                    <img src="/img/app/recharge/yes.png" alt="" style={{ display: `${this.state.langState == 3 ? "block" : "none"}` }} />
                    <span>بالعربية</span>
                  </div>
                  <div className="lang-more-content-item" onClick={() => { this.onChangeLang(4) }}>
                    <img src="/img/app/recharge/yes.png" alt="" style={{ display: `${this.state.langState == 4 ? "block" : "none"}` }} />
                    <span>Türkiye</span>
                  </div>
                </div>
              </div>
              <div className="lang-more-content-wrap" style={{
                display: `${this.state.langState == 3 ? "block" : "none"}`,
                right: `-2.7rem`
              }}>
                <div className="lang-more-content" style={{ transform: `translateY(${this.state.isLang ? "0rem" : "-30vh"})` }}>
                  <div className="lang-more-content-item" onClick={() => { this.onChangeLang(1) }}>
                    <img src="/img/app/recharge/yes.png" alt="" style={{ display: `${this.state.langState == 1 ? "block" : "none"}` }} />
                    <span>中文</span>
                  </div>
                  <div className="lang-more-content-item" onClick={() => { this.onChangeLang(2) }}>
                    <img src="/img/app/recharge/yes.png" alt="" style={{ display: `${this.state.langState == 2 ? "block" : "none"}` }} />
                    <span>English</span>
                  </div>
                  <div className="lang-more-content-item" onClick={() => { this.onChangeLang(3) }}>
                    <img src="/img/app/recharge/yes.png" alt="" style={{ display: `${this.state.langState == 3 ? "block" : "none"}` }} />
                    <span>بالعربية</span>
                  </div>
                  <div className="lang-more-content-item" onClick={() => { this.onChangeLang(4) }}>
                    <img src="/img/app/recharge/yes.png" alt="" style={{ display: `${this.state.langState == 4 ? "block" : "none"}` }} />
                    <span>Türkiye</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="official-recharge-header-bottom">
          <div className="banner">
            <div className="swiper">
              <div className="swiper-wrapper">

                <div className="swiper-slide" >
                  <a href={this.state.bannerList[this.state.langState].url}>
                    <img src={this.state.bannerList[this.state.langState].img} alt="" />
                  </a>
                </div>

              </div>
            </div>
          </div>
          <div className="account">
            {false && <div className="ruby-agent-tab">
              <div
                onClick={() => {
                  this.onChangeTab(1)
                }}
                className={`ruby-agent-tab-item ${!goldOrRuby ? 'ruby-agent-tab-item-active' : ''}`}
              >
                {this.state.lang.gold}
              </div>
              {/* (this.state.uid == 433031 || this.state.uid == 115194 || this.state.uid == 100632 || this.state.uid==10000) && */}
              {
                <div
                  onClick={() => {
                    this.onChangeTab(2)
                  }}
                  className={`ruby-agent-tab-item ${goldOrRuby ? 'ruby-agent-tab-item-active' : ''}`}
                >
                  {this.state.lang.ruby}
                </div>
              }
            </div>}
            <div className="top">
              <span className='title'>
                {this.state.langObj.ra}
              </span>
              <span
                onClick={() => { this.onClearId() }}
                className='other' style={{ display: `${this.state.searchUser ? "block" : "none"}` }}>
                {this.state.langObj.otherId}
              </span>
            </div>
            <div className="center" style={{ display: `${this.state.searchUser ? "none" : "flex"}` }}>
              <input
                type="text"
                value={this.state.inputValue}
                placeholder={this.state.langObj.eu}
                onChange={(e) => {
                  e.persist();
                  this.handleInput(e)
                }} />
              <div className="btn" onClick={() => { this.onHandleSearch() }}>
                {this.state.langObj.search}
              </div>
            </div>
            <div className="center2" style={{ display: `${this.state.searchUser ? "flex" : "none"}` }}>
              <img className='pic' src={this.state.userInfo && this.state.userInfo.avatarurl} alt="" />
              <div className="info">
                <div className="name">{this.state.userInfo && this.state.userInfo.nickname}</div>
                <div className="id">ID:{this.state.userInfo && this.state.userInfo.duid}</div>
              </div>
            </div>
            <div className="bottom" style={{ display: `${this.state.noFoundUser ? "block" : "none"}` }}>
              <span>{this.state.langObj.noExit}</span>
            </div>
            <div className="bottom" style={{ display: `${this.state.noNull ? "block" : "none"}` }}>
              <span>{this.state.langObj.noNull}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  paySelComp() {
    const canShow = this.state.payList.length > 0 ? "flex" : "none"
    let { payList } = this.state
    return (
      <div className="official-recharge-pay" style={{ display: `${canShow}` }}>
        <div className="official-recharge-pay-wrap" key={99}>
          {payList && payList.map((item, index) => {
            return (
              <div key={index} >
                {this.payMethodComp(item.icon, item.method, index + 1, item.id)}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
  rubyPaySelComp() {
    const canShow = this.state.payList.length > 0 ? "flex" : "none"
    let { rubyPayList } = this.state
    return (
      <div className="official-recharge-pay" style={{ display: `${canShow}` }} key={6015}>
        <div className="official-recharge-pay-wrap" key={99}>
          {rubyPayList.length > 0 && rubyPayList.map((item, index) => {
            return (
              <div key={index} >
                {this.payMethodComp(item.icon, item.method, index + 1, item.id)}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
  onChangeTab = async () => {
    let { goldOrRuby } = this.state
    await this.setState({ goldOrRuby: !goldOrRuby, initShow: true, payState: 1 })
    setTimeout(() => {
      this.setState({
        initShow: false
      })
    }, 100)
  }
  render() {
    let { langShow, goldOrRuby, uid, showWhatPay, payList, rubyPayList, payState, payId, priceIndex, identifier, userInfo } = this.state
    // 禁止外部用户访问测试充值网址
    /* 
    if (uid != 102366 &&  config.host == "https://api-test.thechatie.com"  ) {
      return (<div></div>)
    }  */
    return (
      <div className={`official-recharge-main-wrapper ${this.state.langState == 3 && 'arlang'}`} >

        <LoadingComp show={this.state.initShow} />
        <Message ref="msg" desc={this.state.desc} />

        {/* 头部 */}
        {this.headerComp()}

        {/* 选择国家 */}
        {this.selNationComp()}
        {/* 展示档位 */}
        {goldOrRuby && rubyPayList[0] && this.payPriceComp(payState, rubyPayList[payState - 1].list)}
        {!goldOrRuby && payList[0] && this.payPriceComp(payState, payList[payState - 1].list)}
        {/* 支付选择 */}
        {!goldOrRuby && this.paySelComp()}
        {goldOrRuby && this.rubyPaySelComp()}
        {/* 支付policy 模块 */}
        <div className="official-recharge-policy">
          <div className="official-recharge-pay-btn" onClick={() => { this.onHandleRecharge() }}>
            {this.state.langObj.r}
          </div>
        </div>
        {/* 国家选择模块 */}
        {this.nationSelComp()}
        <div style={{ display: "none" }}>
          <img src="/img/app/recharge/active.png" alt="" />
          <img src="/img/gold.png" alt="" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/recharge/index.js